import { UserActivities } from "../enums/user-activities.enum";
import { keyBy } from 'lodash-es';

export class UserActivityOption {
  constructor(public value: string, public display: string) {}
}

export const userActivityOptions = [
  new UserActivityOption(UserActivities.bulkUpdateNameMappings, "Bulk Update Name Mappings"),
  new UserActivityOption(UserActivities.login, "Login"),
  new UserActivityOption(UserActivities.logout, "Logout"),
  new UserActivityOption(UserActivities.auto_logout, "Auto Logout"),
  new UserActivityOption(UserActivities.offline, "Offline"),
  new UserActivityOption(UserActivities.approvedPatientMatch, "Approved Patient Match"),
  new UserActivityOption(UserActivities.rejectedPatientMatch, "Rejected Patient Match"),
  new UserActivityOption(UserActivities.transitionCapture, "Transition Capture"),
  new UserActivityOption(UserActivities.addCaptureDetails, "Add Capture Details"),
  new UserActivityOption(UserActivities.reprocessCapture, "Reprocess Capture"),
  new UserActivityOption(UserActivities.unverifyCapture, "Unverify Capture"),
  new UserActivityOption(UserActivities.createAuditOutcome, "Create Audit Outcome"),
  new UserActivityOption(UserActivities.setVerifyingPatientAttachmentCapture, "Set Verifying Patient Attachment Capture"),
  new UserActivityOption(UserActivities.logInboundCall, "Log Inbound Call"),
  new UserActivityOption(UserActivities.transitionFax, "Transition Fax"),
  new UserActivityOption(UserActivities.addOfficeNote, "Add Office Note"),
  new UserActivityOption(UserActivities.addProviderNote, "Add Provider Note"),
  new UserActivityOption(UserActivities.addProviderOfficeNote, "Add Provider Office Note"),
  new UserActivityOption(UserActivities.clearOfficeReviewStatus, "Clear Office Review Status"),
  new UserActivityOption(UserActivities.createOffice, "Create Office"),
  new UserActivityOption(UserActivities.editOfficeDetails, "Edit Office Details"),
  new UserActivityOption(UserActivities.createProvider, "Create Provider"),
  new UserActivityOption(UserActivities.editProviderDetails, "Edit Provider Details"),
  new UserActivityOption(UserActivities.logOutboundCall, "Log Outbound Call"),
  new UserActivityOption(UserActivities.clearProviderOfficeReviewStatus, "Clear Provider Office Review Status"),
  new UserActivityOption(UserActivities.createProviderOfficeConnection, "Create Provider Office Connection"),
  new UserActivityOption(UserActivities.editProviderOfficeDetails, "Edit Provider Office Details"),
  new UserActivityOption(UserActivities.assignProviderReview, "Assign Provider Review"),
  new UserActivityOption(UserActivities.assignmentConsultNote, "Assignment Consult Note"),
  new UserActivityOption(UserActivities.submitConsultNote, "Submit Consult Note"),
  new UserActivityOption(UserActivities.advancePatientPrescriber, "Advance Patient Prescriber"),
  new UserActivityOption(UserActivities.submitClientConsultNoteTask, "Submit Client Consult Note Task"),
  new UserActivityOption(UserActivities.submitClientReferralTask, "Submit Client Referral Task"),
  new UserActivityOption(UserActivities.transitionClientPrescriberTask, "Transition Client Prescriber Task"),
];

export const keyedUserActivitiesOptions = keyBy(userActivityOptions, 'value');
